/**
 * Mode audit avancé — comparaison ledger stocké vs métier multi-signaux (lecture seule).
 */

export function formatRatePct(percent, fixed = 0) {
  const pct = Number(percent) || 0;
  const fix = Number(fixed) || 0;
  const parts = [];
  if (pct > 0) parts.push(`${pct}%`);
  if (fix > 0) parts.push(`${fix} €`);
  return parts.length ? parts.join(' + ') : '—';
}

export function formatEuro(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return `${v.toFixed(2)} €`;
}

export function formatGap(n) {
  const v = Number(n) || 0;
  if (Math.abs(v) < 0.005) return '0,00 €';
  const sign = v > 0 ? '+' : '';
  return `${sign}${v.toFixed(2)} €`;
}

/** Index audit API lines by ledger row id. */
export function indexMetierAuditLines(auditResponse) {
  const map = {};
  for (const line of auditResponse?.lines || []) {
    if (line.ledger_id) map[line.ledger_id] = line;
  }
  return map;
}

export function metierAuditRowStyle(line) {
  if (!line?.has_metier_analysis) return '';
  if (line.type_mismatch || Math.abs(line.commission_gap || 0) > 0.01) {
    return 'bg-rose-950/25 border-l-2 border-l-rose-500';
  }
  return '';
}

export function metierAuditTotals(auditResponse) {
  return auditResponse?.totals || {
    ledger_commission: 0,
    metier_commission_theoretical: 0,
    gap: 0,
    rows_in_scope: 0,
    rows_analyzed: 0,
    rows_type_mismatch: 0,
  };
}
